import React, { useState, useEffect } from 'react';
import { globalShortcutsService } from '../services/globalShortcutsService';
import GlobalEntitySearch from '../components/Space/GlobalEntitySearch/GlobalEntitySearch';

export const useGlobalEntitySearchShortcut = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    globalShortcutsService.register({
      id: 'global_entity_search',
      key: 'k',
      modifiers: { cmd: true },
      description: 'Open global search',
      handler: () => {
        setIsOpen(prev => !prev);
      },
    });

    return () => globalShortcutsService.unregister('global_entity_search');
  }, []);

  const GlobalEntitySearchModal = isOpen
    ? <GlobalEntitySearch onClose={() => setIsOpen(false)} />
    : null;

  return { GlobalEntitySearchModal };
};
